/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DocsIcon16Light } from './DocsIcon16Light';
import { DocsIcon16Regular } from './DocsIcon16Regular';
import { DocsIcon16Solid } from './DocsIcon16Solid';
import { DocsIcon20Light } from './DocsIcon20Light';
import { DocsIcon20Regular } from './DocsIcon20Regular';
import { DocsIcon20Solid } from './DocsIcon20Solid';
import { DocsIcon24Regular } from './DocsIcon24Regular';
import { DocsIcon24Solid } from './DocsIcon24Solid';
import { DocsIcon32Regular } from './DocsIcon32Regular';
import { DocsIcon64Regular } from './DocsIcon64Regular';
var sizes = {
    16: {
        light: DocsIcon16Light,
        regular: DocsIcon16Regular,
        solid: DocsIcon16Solid,
    },
    20: {
        light: DocsIcon20Light,
        regular: DocsIcon20Regular,
        solid: DocsIcon20Solid,
    },
    24: {
        regular: DocsIcon24Regular,
        solid: DocsIcon24Solid,
    },
    32: {
        regular: DocsIcon32Regular,
    },
    64: {
        regular: DocsIcon64Regular,
    },
};
export var DocsIcon = forwardRef('DocsIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
